export var SpectrophotometerMode;
(function (SpectrophotometerMode) {
    SpectrophotometerMode[SpectrophotometerMode["transmittance"] = 0] = "transmittance";
    SpectrophotometerMode[SpectrophotometerMode["absorbance"] = 1] = "absorbance";
    SpectrophotometerMode[SpectrophotometerMode["concentration"] = 2] = "concentration";
    SpectrophotometerMode[SpectrophotometerMode["factor"] = 3] = "factor";
})(SpectrophotometerMode || (SpectrophotometerMode = {}));
export const SpectroPhotometerModeNames = [
    'TRANSMITTANCE', 'ABSORBANCE',
];
export { Apparat } from './Apparat';
export { SpectrophotometerScreen } from './SpectrophotometerScreen';
